import css from "./PulseHighlighter.module.css";
import { useTour } from "@reactour/tour";
import { useEffect } from "react";

export default function PulseHighlighter({ steps }) {
  const { isOpen, currentStep } = useTour();

  useEffect(() => {
    if (!isOpen) {
      document
        .querySelectorAll(`.${css.pulse}`)
        .forEach(el => el.classList.remove(css.pulse));
      return;
    }

    const step = steps[currentStep];
    if (!step) return;

    // ❗ працює тільки якщо у степа pulse = true
    if (!step.pulse) return;

    const el = document.querySelector(step.selector);
    if (!el) return;

    el.classList.add(css.pulse);

    return () => {
      el.classList.remove(css.pulse);
    };
  }, [isOpen, currentStep, steps]);

  return null;
}
